import { useState } from 'react';
import styles from 'styles/modules/Dropdown.module.scss';
import ArrowDown from './Svg/ArrowDown';

const OptionSelect = ({
    options,
    register,
    value: { value },
    setValue,
    defaultValue,
}) => {
    const [showList, setShowList] = useState(false);

    return (
        <div className={[styles.dropdown, styles.inline].join(' ')}>
            <div
                className={[styles.input, styles.inputSelect].join(' ')}
                onClick={() => setShowList(!showList)}
            >
                {value}
                <ArrowDown />
            </div>
            {showList && (
                <div className={styles.listWrapper}>
                    <ul className={styles.list}>
                        {defaultValue && (
                            <li
                                className={styles.listItem}
                                onClick={() => {
                                    setValue({
                                        id: undefined,
                                        value: defaultValue,
                                    });
                                    setShowList(false);
                                }}
                            >
                                {defaultValue}
                            </li>
                        )}
                        {options.map(
                            ({ id, name, position, imageUrl, ...rest }) => {
                                return (
                                    <li
                                        className={styles.listItem}
                                        onClick={() => {
                                            setValue({
                                                id,
                                                value: name,
                                                ...(imageUrl && {
                                                    image: imageUrl,
                                                }),
                                                name,
                                                position,
                                                ...rest,
                                            });
                                            setShowList(false);
                                        }}
                                        key={`option-select-${id}`}
                                    >
                                        <div className={styles.inner}>
                                            {imageUrl && (
                                                <div className={styles.image}>
                                                    <img
                                                        src={imageUrl}
                                                        alt={name}
                                                    />
                                                </div>
                                            )}
                                            <div>
                                                <h4>{name}</h4>
                                                <span>{position}</span>
                                            </div>
                                        </div>
                                    </li>
                                );
                            }
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default OptionSelect;
